exports.ensureCtx = function(ctx) {
    return ctx || SP.ClientContext.get_current();
};

// Promisify
var executeBatch = exports.executeBatch = function(ctx) {
    return new Promise((resolve, reject) => ctx.executeQueryAsync(resolve, reject));
}

// Collections come back super wonky and complex.  Turn them into a generic js array
exports.collectionToArray = function(collection, mapper) {
	var enumerator = collection.getEnumerator();
	var array = [];
	while (enumerator.moveNext()) {
		var item = enumerator.get_current();
		if (mapper && typeof mapper === "function") {
			item = mapper(item);
		}
		array.push(item);
	}
	return array;
};



// WEBPACK FOOTER //
// ./src/scripts/jsom/utils.js